/**
 * client.ts — cliente Supabase para el browser.
 *
 * Singleton: una sola instancia compartida en toda la app de cliente.
 * Usa la `anon key` (segura para front) y respeta las RLS policies del
 * proyecto. Para operaciones privilegiadas (scripts, edge), ver `server.ts`.
 */

import { createClient, type SupabaseClient } from '@supabase/supabase-js';

import { requireEnv } from '../env';
import type { Database } from './types';

const SUPABASE_URL = requireEnv('VITE_SUPABASE_URL');
const SUPABASE_ANON_KEY = requireEnv('VITE_SUPABASE_ANON_KEY');

/**
 * Cliente Supabase tipado con el `Database` schema.
 * Singleton — importar desde aquí siempre, no instanciar de nuevo.
 */
export const supabase: SupabaseClient<Database> = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      // Persistir sesión en localStorage para SPA y refrescar tokens automáticamente.
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);

/** Tipo del cliente para anotar handlers/hooks que lo reciben por inyección. */
export type TypedSupabaseClient = SupabaseClient<Database>;
